<template>
<div class="chapter">
<div class="inner_page">
<a id="page_18"></a>
<h3 class="chap-num">Seven</h3>
<h3 class="chap-title">The arrest</h3>
<p class="noindent">Dad was serene. He didn’t even smile at the absurdity of their accusation. He put on his boots with a dignity that got on their nerves. The policemen began to hurry and hassle him, but Dad put on his boots more slowly, so they lost their tempers, punching and kicking him. Dad regarded them coolly, with pity almost. I jumped on one of the policemen, who threw me on the bed.</p>
<p class="indent">‘Sit still and watch, you cricket!’ Dad said to me, his voice raised.</p>
<p class="indent">I sat still. I watched as they dragged him out with only one boot on. Dad didn’t resist, but didn’t comply. They had to carry him out into the street, where our neighbours were gathered, demanding in angry voices why the policemen were arresting a good man. But when the policemen threatened them with imprisonment, everyone fell silent.</p>
<p class="indent">We all followed the policemen as they carried Dad to their van. But before they managed to throw him into the back, Dad managed a defiant cry and a cryptic statement:</p>
<p class="indent">‘J<span class="small">USTICE IS A BLACK GOD</span>!’ He shouted.</p>
<a id="page_19"></a>
<p class="indent">They slammed the door on his mad voice and drove away before we could find out where they were taking him.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013_Part01Sub01Ch07.vue?8245eeb2